import { createGlobalStyle } from 'styled-components';

import 'normalize.css';
import iubendaStyle from './iubendaStyle';
import dropdownStyle from './dropdownStyle';
import tableStyle from './tableStyle';
import media from '../media';

const GlobalStyle = createGlobalStyle`

/*
TODO: @import statements support is broken in the latest styled-components.
We put fonts directly in the index html instead.
This has an advantage of faster fonts loading too. Maybe we should keep it that way.
*/
/* @import url(${({ theme }) => theme.fontsUrl}); */
/* @import url(${({ theme }) => theme.logoFontUrl}); */

${iubendaStyle}
${tableStyle}
/* TODO: the dropdown style may be moved closer to datepicker */
${dropdownStyle}

*, *:before, *:after {
  box-sizing: border-box;
}

body {
  ${({ theme }) => theme.typography.regular}
  color: #000000;
}


.hidden {
  display: none;
}

.clickable {
  cursor: pointer;
}

.clickable:active {
  color: orange;
}

a {
  color: #337ab7;
  text-decoration: none;
}

a:hover,
a:focus {
  color: #23527c;
  text-decoration: underline;
}

a:focus {
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

a.link-emph {
  color: ${({ theme }) => theme.color.link};
  text-decoration: none;
  font-weight: bolder;
}

h1 {
  ${({ theme }) => theme.typography.h1}

  margin-top: 30px;
  margin-bottom: 15px;
  ${media.sm} {
    margin-top: 88px;
    margin-bottom: 16px;
  }
}

h2 {
  ${({ theme }) => theme.typography.h2}

  margin-top: 30px;
  margin-bottom: 12px;
  ${media.sm} {
    margin-top: 44px;
    margin-bottom: 21px;
  }
}

h3 {
  ${({ theme }) => theme.typography.h3}
  
  margin-top: 30px;
  margin-bottom: 12px;
  ${media.sm} {
    margin-top: 30px;
    margin-bottom: 16px;
  }
}

h4, h5 {
  margin-top: 20px;
  margin-bottom: 10px;
  ${({ theme }) => theme.typography.h4}
}

small {
  ${({ theme }) => theme.typography.small}
}

b, strong {
  ${({ theme }) => theme.typography.strong}
}

.text-muted {
  color: ${({ theme }) => theme.color.muted};
}

hr {
  border-color: ${({ theme }) => theme.color.hr};
}

a.non-text-link {
  text-decoration: none;
  color: inherit;
}

.btn {
  ${({ theme }) => theme.button.font}
  font-size: 16px;
  line-height: 20px;
  padding: 13px 20px;
  border-radius: 23px;
  border: none;
  font-weight: 700;
  cursor: pointer;
  transition: ${({ theme }) => theme.button.transition};
}

.btn-xs {
  font-size: 12px;
  line-height: 14px;
  padding: 1px 5px;
  border-radius: 8px;
}

.btn-sm {
  font-size: 12px;
  line-height: 14px;
  padding: 5px 9px;
  border-radius: 12px;
}

.btn-default {
  border: 1px solid ${({ theme }) => theme.button.borderColor.secondary};
  &, &:focus {
    background-color: #ffffff;
    color: ${({ theme }) => theme.button.color.primary};
  }
}

.btn-primary {
  border: 1px solid ${({ theme }) => theme.button.borderColor.primary};
  &, &:focus {
    background: ${({ theme }) => theme.button.background.primary};
    color: #ffffff;
  }
}

.btn-default, .btn-primary, .btn-text {
  &:hover {
    background: ${({ theme }) => theme.button.background.hover} no-repeat;
    border-color: ${({ theme }) => theme.button.borderColor.hover};
    color: #ffffff;
  }

  &:focus {
    border-color: ${({ theme }) => theme.button.borderColor.focus} !important;
  }

  &:active, &:active:focus, &:active:hover {
    background: ${({ theme }) => theme.button.background.click} no-repeat;
    border-color: ${({ theme }) => theme.button.borderColor.hover};
    color: #ffffff;
  }
}

.btn-default, .btn-primary {
  &:disabled, &:disabled:hover, &:disabled:active {
    transform: none;
    border: 1px solid ${({ theme }) => theme.button.borderColor.disabled};
    background: ${({ theme }) => theme.button.background.disabled};
    color: #ffffff;
  }
}

.btn-text {
  color: ${({ theme }) => theme.color.link};
  background-color: #ffffff;

  &:disabled, &:disabled:hover, &:disabled:active {
    color: ${({ theme }) => theme.button.borderColor.disabled};
  }
}

.btn-text-inline {
  color: ${({ theme }) => theme.color.link};
  background-color: #ffffff;
  padding: 0px;
  cursor: pointer;

  &:disabled, &:disabled:hover, &:disabled:active {
    color: ${({ theme }) => theme.button.borderColor.disabled};
  }
}

img {
  vertical-align: middle;
  border: 0px;
}

.img-circle {
  border-radius: 50%;
}

.text-center {
  text-align: center;
}

input,
button,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

.form-control {
  width: 100%;
  line-height: 1.42857143;

  color: #555;
  padding: 6px 12px;
  border-radius: 3px;

  font-size: 16px;
  border: 1px solid ${({ theme }) => theme.form.color.border};
  ::placeholder {
    color: ${({ theme }) => theme.form.color.placeholder};
  }
  :focus {
    border-color: ${({ theme }) => theme.form.color.borderFocus};
  }
}

.form-group {
  margin-bottom: 15px;
}

.has-feedback {
  position: relative;
}

.form-control-feedback {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  display: block;
  width: 34px;
  height: 34px;
  line-height: 34px;
  text-align: center;
}

label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: bolder;
}

textarea.form-control {
  height: auto;
}

.has-error {
  .control-label, .help-block {
    color: ${({ theme }) => theme.color.error};
  }
  .form-control {
    border-color: ${({ theme }) => theme.color.error};
  }
}

.error-msg {
  display: inline-block;
  color: ${({ theme }) => theme.color.error};
}

.description-text {
  white-space: pre-line;
  word-wrap: break-word;
}
`;

export default GlobalStyle;
